import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Check, IsClosed, IsOpen, CircleTimes, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { HBox, VBox } from '../../../../components/Box';
import { List, Row, Cell } from '../../../../components/List';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import { deleteVehicleProperty, setVehicleProperty } from '../../../Vehicles/actions';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { Input } from '../../../../components/Input';
import { FormField } from '../../../../components/FormFields';
import { UserLabelById } from '../../../Users/components/UserLabelById';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';

import { Cell as ActionCell } from '../Cell';
import { selectVehicle } from '../../../Vehicles/selectors';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { dropRightWhile } from 'lodash';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { getRemarkType } from '../helpers/getRemarkType';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { selectUserId, selectWork } from '../../../Api/selectors';

import cn from 'classnames';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './WS_Default.module.css';

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};

const Container = styled.div`
  .form-controlField,
  .form-controlField .decorated,
  .vehicle-property-loadable.comment {
    width: 100%;
  }
  .comment-text {
    padding: 6px;
    margin-bottom: 12px;
    border-bottom: 1px solid #eee;
  }
  .pane {
    border-top: 1px solid #eee;
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    width: 100%;
    margin-bottom: 12px;
    border-bottom: none;

    .title {
      text-transform: uppercase;
    }
    h1 {
      font-size: 18px;
    }
  }

  .triple {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 12px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      width: 24px;
      height: 24px;
      font-size: 16px;
      font-weight: 600;
      line-height: 20px;
      display: flex;
      align-items: stretch;
      justify-content: center;
      background-color: #0183d5;
      color: #fff;
      border-radius: 0.375rem;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        background-color: var(--color-new-secondary);
      }
    }
    &.triple-2 {
      .check {
        background-color: #fa5c7c;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }

    .attention {
      color: ${COLOR_PRIMARY_1};

      .plus {
        background-color: #0183d5;
        color: #fff;
        border-radius: 0.375rem;
        width: 24px;
        height: 24px;
        text-align: center;
        font-weight: 600;
        margin: 0 6px;
      }
    }
    .vehicle-property-loadable {
      display: inline-block;
    }
  }
`;

const STATE = {
  approve: false,
  value: '',
  'testdrive-data': false,
};

const TASK_REMARK_TYPE = 'Testdrive';

/* eslint-disable react/prefer-stateless-function */
class WS1_4_TestDriveComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  onNotTestDrivenBtn() {
    ['nottestdriven', 'task_test_drive_complete', 'task_test_drive'].map(name => {
      if (name == 'task_test_drive') {
        return this.props.setProperty(name, '0');
      }
      return this.props.setProperty(name, '1');
    });
    return this.setState({ approve: false });
  }

  propertyValue(name) {
    return this.vehicle?.[name];
  }

  renderPane(name, title, content) {
    return (
      <>
        <div className="d-flex w-100">
          <div
            className={cn(styles.accordionHeader, { [styles.openAccordionHeader]: this.state[name] })}
            onClick={this.setStateFn({ [name]: !this.state[name] })}
          >
            {title}
          </div>
          <div
            className={cn(styles.accordionIcon, { [styles.openAccordionIcon]: this.state[name] })}
            onClick={this.setStateFn({ [name]: !this.state[name] })}
          >
            {this.state[name] ? <IsClosed /> : <IsOpen />}{' '}
          </div>
        </div>
        {this.state[name] ? content : null}
      </>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent
        onClose={this.reset.bind(this)}
        title={
          <>
            {this.props.fullFetch ? (
              <>
                <Loader small />
                &nbsp;
              </>
            ) : null}
            {this.props.action.label}
          </>
        }
      >
        <Container>
          {this.renderModalBody()}

          <div className="d-flex gap-2 flex-wrap mt-2">
            <ButtonComponent style={'ButtonSoftEdit'} onClick={this.props.confirm}>
              {this.lbl('confirm')}
            </ButtonComponent>
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.setStateFn({ approve: false })}>
              {this.lbl('cancel')}
            </ButtonComponent>
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.onNotTestDrivenBtn.bind(this)}>
              {this.lbl('vehicle.nottestdriven')}
            </ButtonComponent>
          </div>
        </Container>
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <ActionCell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <Label count={vehicle?.walstreet_proefrit_doorlooptijd_counter} ranges={ranges}>
            {vehicle?.walstreet_proefrit_doorlooptijd_counter || '0'}
          </Label>
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
          {this.renderApprove()}
        </Container>
      </ActionCell>
    );
  }

  renderModalBody() {
    return (
      <>
        <WithVehicle vehicle_id={this.props.cell.vehicle.id} loader>
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} />
          </div>
          <VBox className={`${this.props.fullFetch ? 'loading' : ''}`} key="body">
            {this.renderPane(
              'purchase-data',
              this.lbl('interior.inspection.purchase-data'),
              <>
                <List className={styles.listContainer}>
                  <Row>
                    <Cell>{this.lbl(`vehicle.property.creditor_company`)}</Cell>
                    <Cell>
                      <CompanyLabelById company_id={this.vehicle.creditor_company} />
                    </Cell>
                  </Row>

                  <Row>
                    <Cell>{this.lbl(`vehicle.property.buying_company`)}</Cell>
                    <Cell>
                      <CompanyLabelById company_id={this.vehicle.buying_company} />
                    </Cell>
                  </Row>

                  <Row>
                    <Cell>{this.lbl(`vehicle.property.buying_contact`)}</Cell>
                    <Cell>
                      <UserLabelById user_id={this.vehicle.buying_contact} />
                    </Cell>
                  </Row>

                  <Row>
                    <Cell>{this.lbl(`vehicle.property.mileage`)}</Cell>
                    <Cell>{this.vehicle.mileage || '-'}</Cell>
                  </Row>
                </List>
              </>,
            )}

            {this.renderPane(
              'testdrive-data',
              this.lbl('vehicle.testdrive'),

              <VBox className="test-drive-items">
                {['engine_general', 'ac', 'brakes', 'transmission', 'drive', 'electrics'].map(
                  this.renderTripleCheck.bind(this),
                )}
                <HBox vCenter left className="triple triple-1">
                  <div
                    className="check"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      ['engine_general', 'ac', 'brakes', 'transmission', 'drive', 'electrics'].map(type => {
                        this.props.setProperty(`state_${type}`, 1);
                      });
                    }}
                  >
                    +
                  </div>
                  <div className="label" style={{ whiteSpace: 'nowrap' }}>
                    {this.lbl(`all`)}
                  </div>
                </HBox>
              </VBox>,
            )}
          </VBox>
        </WithVehicle>
      </>
    );
  }

  renderTripleCheck(name) {
    name = 'state_' + name;
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 ? 2 : 0;
    console.log(name + ' : ' + state);
    return (
      <VBox key={name}>
        <HBox vCenter left key={name} className={cn(`triple triple-${state}`, styles.containerCheckPlus)}>
          <HBox
            vCenter
            className="gap-2"
            left
            // onClick={() => this.props.setProperty(name, state == 0 ? 1 : state == 1 ? 2 : 0)}
          >
            <div className="label" style={{ whiteSpace: 'nowrap' }}>
              {this.lbl(`vehicle.property.${name}`)}
            </div>
            <VehiclePropertyLoadable name={name}>
              <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input
                  type="radio"
                  className="btn-check"
                  name={`btnradio-${name}`} // uniek per veld
                  id={`btnradio1-${name}`}
                  autoComplete="off"
                  checked={state == 0}
                  onChange={() => this.props.setProperty(name, 0)}
                />
                <label className="btn btn-outline-primary" htmlFor={`btnradio1-${name}`}>Todo</label>

                <input
                  type="radio"
                  className="btn-check"
                  name={`btnradio-${name}`}
                  id={`btnradio2-${name}`}
                  autoComplete="off"
                  checked={state == 1}
                  onChange={() => this.props.setProperty(name, 1)}
                />
                <label className="btn btn-outline-primary" htmlFor={`btnradio2-${name}`}>Gereed</label>

                <input
                  type="radio"
                  className="btn-check"
                  name={`btnradio-${name}`}
                  id={`btnradio3-${name}`}
                  autoComplete="off"
                  checked={state == 2}
                  onChange={() => this.props.setProperty(name, 2)}
                />
                <label className="btn btn-outline-primary" htmlFor={`btnradio3-${name}`}>Manco</label>
              </div>
            </VehiclePropertyLoadable>

          </HBox>
          {this.renderCommentToggle(name)}
        </HBox>
        <VehiclePropertyLoadable className="comment" name={`${name}_comment`}>
          {this.renderCommentInput(name)}
        </VehiclePropertyLoadable>
      </VBox>
    );
  }

  renderCommentToggle(name) {
    name = name + '_comment';
    let value = this.propertyValue(name);

    if (this.state.edit == name) {
      return (
        <HBox key={name} className="attention" vCenter right onClick={this.setStateFn({ edit: null, value: null })}>
          <div className="plus">-</div>
        </HBox>
      );
    }
    return (
      <HBox
        key={`${name}-2`}
        className="attention"
        vCenter
        right
        onClick={this.setStateFn({ edit: name, value: value || '' })}
      >
        <span>Aandachtspunt</span>
        <div className="plus">+</div>
      </HBox>
    );
  }

  renderCommentInput(name) {
    name = name + '_comment';
    let value = this.propertyValue(name);
    if (this.state.edit == name) {
      return (
        <div className={styles.buttonGroupInput}>
          <div className={styles.input}>
            <input
              key={name}
              name="value"
              onChange={this.onInputChange.bind(this)}
              value={this.state.value}
              type="text"
              className="form-control"
            />
          </div>

          <div className={styles.buttons}>
            <ButtonComponent
              style={'ButtonSoftPrimary'}
              onClick={() => {
                this.props.setProperty(name, this.state.value);
                this.setState({ edit: null });
              }}
            >
              <Check />
            </ButtonComponent>

            <ButtonComponent
              style={'ButtonSoftDelete'}
              onClick={() => {
                this.props.deleteProperty(name);
                this.setState({ edit: null });
              }}
            >
              <CircleTimes />
            </ButtonComponent>
          </div>
        </div>
      );
    }

    if (!value || value == '') return null;

    return <div className="comment-text">{value}</div>;
  }
}

WS1_4_TestDriveComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm() {
      dispatch(performAction(ownProps.action.id, ownProps.cell.vehicle.id));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
    deleteProperty(name) {
      dispatch(deleteVehicleProperty(ownProps.cell.vehicle.id, name));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WS1_4_TestDrive = compose(withConnect, withRouter)(WS1_4_TestDriveComp);
